import { SequenceManagerAction } from "./SequenceManagerAction";

const ContractLengthAction = {
  MONTHS_SELECTION: "MONTHS_SELECTION",
} as const;

const monthsSelection = (selection: any, offerContainerId: any) => {
  return function (dispatch: any) {
    dispatch({ type: ContractLengthAction.MONTHS_SELECTION, payload: { selection: selection, offerContainerId: offerContainerId } });
    dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['ContractLength'] });
  };
};

export { ContractLengthAction, monthsSelection };